export default __webpack_public_path__ + "static/media/WebsiteLogo.27f486f9.svg";